import { notifyParent } from 'Helpers/notifyParent'
import { EmptyState, Panel } from 'mailup-web-components'
import emptyStateImage from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-dynamic-content.svg'

import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import { pageState } from '../../recoil/state/page'
import Footer from '../Footer'
import Results from '../Results'

const SectionContents = () => {
  const intl = useIntl()
  const { isEmptyState, error, loaded } = useRecoilValue(pageState)

  const handleClick = () => {
    notifyParent('redirectMainFrame', [`/console/GestoreContenutiEsterni.aspx`])
  }

  return (
    <>
      {!error &&
        loaded &&
        (isEmptyState ? (
          <Panel>
            <EmptyState
              thumbSrc={emptyStateImage}
              title={intl.formatMessage({
                id: 'Load.DynamicFieldList.EmptyStateDynamicContentListTitle'
              })}
              description={intl.formatMessage({
                id: 'Load.DynamicFieldList.EmptyStateDynamicContentListDescription'
              })}
              buttonText={intl.formatMessage({
                id: 'Load.DynamicContentList.AddNew'
              })}
              onClickButton={handleClick}
            />
          </Panel>
        ) : (
          <>
            <Panel>
              <Results />
            </Panel>
            <Footer />
          </>
        ))}
    </>
  )
}

export default SectionContents
